export const translations = {
  tr: {
    // Nav
    nav: { home: "Anasayfa", services: "Hizmetler", work: "Projeler", about: "Hakkımızda", blog: "Blog", pricing: "Fiyatlar", contact: "İletişim", getInTouch: "İletişime Geç" },
    // Home
    home: {
      heroLine1: "Markanızı",
      heroLine2: "Zirveye",
      heroLine3: "Taşıyoruz.",
      heroSubtitle: "Dijital Dünyada Fark Yaratan Tek Ajans",
      scroll: "Aşağı kaydır",
      statsLabel: "Larcraft Rakamlarla",
      statProjects: "Tamamlanan Proje",
      statSatisfaction: "Müşteri Memnuniyeti",
      statClients: "Aktif Müşteri",
      statYears: "Yıllık Tecrübe",
      whatWeDoLabel: "Ne Yapıyoruz",
      whatWeDoTitle: "Markalara Hayat Veren İşler",
      whatWeDoIntro: "Strateji, kreatif ve teknolojinin kesişiminde; markaları büyüten 360° hizmetler sunuyoruz.",
      recentWorkLabel: "Son Projeler",
      recentWorkTitle: "İz Bırakan İşler",
      recentWorkCta: "Tüm Projeleri Gör",
      testimonialsLabel: "Müşteri Sözleri",
      ctaTitle: "Bir sonraki büyük hikâye sizin markanız olsun.",
      ctaButton: "Bizimle Çalışın",
    },
    services: {
      label: "Hizmetler",
      title: "13 Hizmet, Tek Vizyon",
      intro: "Markanızı dijital dünyada zirveye taşıyan, uçtan uca çözümler.",
      learnMore: "Daha Fazla",
      close: "Kapat",
    },
    portfolio: {
      label: "Projeler",
      title: "Seçilmiş İşler",
      intro: "Sektör fark etmeksizin, sonuç odaklı işler. Detaya tıklayın.",
      all: "Tümü",
      result: "Sonuç",
      year: "Yıl",
      client: "Müşteri",
      category: "Kategori",
      services: "Kullanılan Hizmetler",
      close: "Kapat",
    },
    about: {
      label: "Biz Kimiz",
      title: "Larcraft Medya",
      intro: "2019'dan bu yana, dijitalde fark yaratan markaların arkasındayız.",
      storyTitle: "Hikâyemiz",
      story: "Larcraft, küçük bir İstanbul stüdyosunda başlayan büyük bir vizyondur. Bugün; 50+ aktif müşteri, 150+ proje ve birçok ödülle, dijital dünyada Türkiye'nin en güvenilen kreatif partnerlerinden biriyiz. Veriyi sanatla, stratejiyi kreatifle harmanlıyoruz.",
      valuesTitle: "Değerlerimiz",
      values: [
        { t: "Larcraft", d: "Her işte itibar, her sözde söz." },
        { t: "Cesaret", d: "Standartın ötesinde, fark yaratan fikirler." },
        { t: "Disiplin", d: "Veriyle, takvimle, sonuçla." },
        { t: "Kreatiflik", d: "Sıradan olanı reddederiz." },
        { t: "Şeffaflık", d: "Süreç ve sonuçta net görünürlük." },
        { t: "Ortaklık", d: "Müşteri değil, partneriz." },
      ],
      timelineTitle: "Yolculuğumuz",
      timeline: [
        { y: "2019", t: "Larcraft kuruldu" },
        { y: "2020", t: "İlk uluslararası müşteri" },
        { y: "2021", t: "Kreatif stüdyo açıldı" },
        { y: "2022", t: "PR departmanı kuruldu" },
        { y: "2023", t: "AI Lab başlatıldı" },
        { y: "2025", t: "150+ projeyi aştık" },
      ],
      teamTitle: "Ekip",
      ctaTitle: "Bir sonraki büyük hikâye bizim olsun.",
      ctaButton: "Bizimle Çalışın",
    },
    blog: {
      label: "Larcraft Insights",
      title: "Düşünceler & Trendler",
      search: "Yazılarda ara…",
      all: "Tümü",
      readMore: "Okumaya Devam",
      readTime: "dk okuma",
      empty: "Sonuç bulunamadı.",
      back: "Tüm Yazılar",
      relatedTitle: "Daha Fazla",
    },
    pricing: {
      label: "Yatırım",
      title: "Şeffaf Fiyatlandırma",
      intro: "Her ölçekten markaya özel paketler. İhtiyacınıza göre özelleştirilir.",
      monthly: "Aylık",
      annual: "Yıllık",
      annualDiscount: "%20 indirim",
      popular: "En Popüler",
      cta: "Bu Paketi Seç",
      customTitle: "Ölçeğiniz farklı mı?",
      customText: "Kurumsal & özel projeler için size özel bir teklif hazırlayalım.",
      customCta: "Özel Teklif Al",
      tiers: [
        {
          name: "Starter",
          price: { monthly: 1500, annual: 1200 },
          desc: "Yeni başlayan markalar için temel paket.",
          features: ["3 platform yönetimi", "Aylık 12 içerik", "Aylık raporlama", "1 kreatif kampanya"],
        },
        {
          name: "Growth",
          price: { monthly: 4500, annual: 3600 },
          desc: "Büyüyen markalar için en sevilen seçim.",
          features: ["5 platform + reklam yönetimi", "Aylık 30 içerik", "Haftalık raporlama", "3 kreatif kampanya", "İçerik prodüksiyonu", "Influencer yönetimi"],
        },
        {
          name: "Enterprise",
          price: { monthly: 12000, annual: 9600 },
          desc: "Kurumsal markalar için 360° destek.",
          features: ["Sınırsız platform & reklam", "Sınırsız içerik", "Günlük raporlama", "Marka PR + kriz yönetimi", "Özel hesap yöneticisi", "Aylık strateji workshop'u", "Yıllık marka filmi"],
        },
      ],
    },
    contact: {
      label: "İletişim",
      title: "Konuşalım",
      intro: "İhtiyacınızı yazın; 24 saat içinde size dönüş yapalım.",
      info: "İletişim Bilgileri",
      working: "Çalışma Saatleri",
      response: "24 saat içinde dönüş.",
      form: {
        name: "Adınız Soyadınız",
        email: "E-posta",
        phone: "Telefon",
        company: "Şirket",
        service: "İlgilendiğiniz Hizmet",
        budget: "Bütçe Aralığı",
        message: "Mesajınız",
        submit: "Gönder",
        sending: "Gönderiliyor…",
        success: "Mesajınız iletildi. 24 saat içinde dönüş yapacağız.",
        error: "Bir sorun oluştu. Lütfen tekrar deneyin.",
        budgets: ["<5K", "5K-15K", "15K-50K", "50K+"],
      },
    },
    footer: {
      tagline: "Dijital Dünyada Fark Yaratan Tek Ajans.",
      explore: "Keşfet",
      legal: "Hukuk",
      privacy: "Gizlilik Politikası",
      terms: "Kullanım Koşulları",
      rights: "© 2025 Larcraft Medya. Tüm hakları saklıdır.",
      newsletter: "Larcraft bültenine abone olun.",
      subscribe: "Abone Ol",
      subscribeOk: "Teşekkürler — abone oldunuz.",
    },
    admin: {
      loginTitle: "Larcraft Admin",
      loginSubtitle: "Sadece yetkili kullanıcılar.",
      email: "E-posta",
      password: "Şifre",
      login: "Giriş Yap",
      loggingIn: "Giriş yapılıyor…",
      invalid: "Geçersiz kimlik bilgileri",
      welcome: "Hoşgeldin",
      logout: "Çıkış Yap",
      nav: { dashboard: "Dashboard", messages: "Mesajlar", blog: "Blog", portfolio: "Portföy", services: "Hizmetler", team: "Ekip", settings: "Ayarlar" },
      stats: { total: "Toplam Mesaj", unread: "Okunmamış", posts: "Blog Yazısı", portfolio: "Portföy" },
      recent: "Son Mesajlar",
      save: "Kaydet",
      delete: "Sil",
      edit: "Düzenle",
      new: "Yeni",
      confirm: "Emin misiniz?",
      saved: "Kaydedildi.",
      deleted: "Silindi.",
      status: { all: "Tümü", new: "Yeni", read: "Okundu", replied: "Yanıtlandı" },
      passwordChange: "Şifre Değiştir",
      currentPw: "Mevcut Şifre",
      newPw: "Yeni Şifre",
      changePw: "Şifreyi Güncelle",
    },
  },
  en: {
    nav: { home: "Home", services: "Services", work: "Work", about: "About", blog: "Blog", pricing: "Pricing", contact: "Contact", getInTouch: "Get in Touch" },
    home: {
      heroLine1: "We Elevate",
      heroLine2: "Your Brand",
      heroLine3: "to the Top.",
      heroSubtitle: "The Only Agency That Makes a Difference in the Digital World",
      scroll: "Scroll down",
      statsLabel: "Larcraft in Numbers",
      statProjects: "Projects Delivered",
      statSatisfaction: "Client Satisfaction",
      statClients: "Active Clients",
      statYears: "Years of Craft",
      whatWeDoLabel: "What We Do",
      whatWeDoTitle: "Work That Gives Brands Life",
      whatWeDoIntro: "At the intersection of strategy, creative, and technology — 360° services that grow brands.",
      recentWorkLabel: "Recent Work",
      recentWorkTitle: "Work That Leaves a Mark",
      recentWorkCta: "See All Projects",
      testimonialsLabel: "Client Words",
      ctaTitle: "Let the next big story be your brand.",
      ctaButton: "Work With Us",
    },
    services: {
      label: "Services",
      title: "13 Services, One Vision",
      intro: "End-to-end solutions that elevate your brand in the digital world.",
      learnMore: "Learn More",
      close: "Close",
    },
    portfolio: {
      label: "Work",
      title: "Selected Projects",
      intro: "No matter the industry — results-driven work. Click to see the detail.",
      all: "All",
      result: "Result",
      year: "Year",
      client: "Client",
      category: "Category",
      services: "Services Used",
      close: "Close",
    },
    about: {
      label: "Who We Are",
      title: "Larcraft Medya",
      intro: "Since 2019, we've been the team behind brands that make a difference in digital.",
      storyTitle: "Our Story",
      story: "Larcraft began as a small Istanbul studio with a big vision. Today, with 50+ active clients, 150+ projects and several awards, we are one of Türkiye's most trusted creative partners in the digital world. We blend data with art, strategy with creative.",
      valuesTitle: "Our Values",
      values: [
        { t: "Honor", d: "Reputation in every job, our word in every promise." },
        { t: "Courage", d: "Ideas beyond the standard." },
        { t: "Discipline", d: "Data, calendar, outcomes." },
        { t: "Creativity", d: "We reject the ordinary." },
        { t: "Transparency", d: "Clear visibility in process and result." },
        { t: "Partnership", d: "Not clients, partners." },
      ],
      timelineTitle: "Our Journey",
      timeline: [
        { y: "2019", t: "Larcraft founded" },
        { y: "2020", t: "First international client" },
        { y: "2021", t: "Creative studio opens" },
        { y: "2022", t: "PR department established" },
        { y: "2023", t: "AI Lab launched" },
        { y: "2025", t: "Crossed 150+ projects" },
      ],
      teamTitle: "Team",
      ctaTitle: "Let the next big story be ours.",
      ctaButton: "Work With Us",
    },
    blog: {
      label: "Larcraft Insights",
      title: "Thoughts & Trends",
      search: "Search posts…",
      all: "All",
      readMore: "Continue Reading",
      readTime: "min read",
      empty: "No results.",
      back: "All Posts",
      relatedTitle: "More",
    },
    pricing: {
      label: "Investment",
      title: "Transparent Pricing",
      intro: "Packages crafted for every scale. Tailored to your needs.",
      monthly: "Monthly",
      annual: "Annual",
      annualDiscount: "20% off",
      popular: "Most Popular",
      cta: "Choose This Plan",
      customTitle: "A different scale?",
      customText: "For enterprise & bespoke projects, let's craft a custom proposal.",
      customCta: "Get Custom Quote",
      tiers: [
        {
          name: "Starter",
          price: { monthly: 1500, annual: 1200 },
          desc: "Foundational package for new brands.",
          features: ["3 platform management", "12 monthly contents", "Monthly reporting", "1 creative campaign"],
        },
        {
          name: "Growth",
          price: { monthly: 4500, annual: 3600 },
          desc: "Most loved choice for growing brands.",
          features: ["5 platforms + ad management", "30 monthly contents", "Weekly reporting", "3 creative campaigns", "Content production", "Influencer management"],
        },
        {
          name: "Enterprise",
          price: { monthly: 12000, annual: 9600 },
          desc: "360° support for enterprise brands.",
          features: ["Unlimited platforms & ads", "Unlimited content", "Daily reporting", "Brand PR + crisis management", "Dedicated account manager", "Monthly strategy workshops", "Annual brand film"],
        },
      ],
    },
    contact: {
      label: "Contact",
      title: "Let's Talk",
      intro: "Tell us what you need; we'll get back within 24 hours.",
      info: "Contact Info",
      working: "Working Hours",
      response: "Response within 24 hours.",
      form: {
        name: "Full Name",
        email: "Email",
        phone: "Phone",
        company: "Company",
        service: "Service of Interest",
        budget: "Budget Range",
        message: "Your Message",
        submit: "Send",
        sending: "Sending…",
        success: "Your message has been sent. We'll respond within 24 hours.",
        error: "Something went wrong. Please try again.",
        budgets: ["<5K", "5K-15K", "15K-50K", "50K+"],
      },
    },
    footer: {
      tagline: "The Only Agency That Makes a Difference in the Digital World.",
      explore: "Explore",
      legal: "Legal",
      privacy: "Privacy Policy",
      terms: "Terms of Use",
      rights: "© 2025 Larcraft Medya. All rights reserved.",
      newsletter: "Subscribe to the Larcraft newsletter.",
      subscribe: "Subscribe",
      subscribeOk: "Thanks — you're subscribed.",
    },
    admin: {
      loginTitle: "Larcraft Admin",
      loginSubtitle: "Authorized users only.",
      email: "Email",
      password: "Password",
      login: "Login",
      loggingIn: "Logging in…",
      invalid: "Invalid credentials",
      welcome: "Welcome",
      logout: "Logout",
      nav: { dashboard: "Dashboard", messages: "Messages", blog: "Blog", portfolio: "Portfolio", services: "Services", team: "Team", settings: "Settings" },
      stats: { total: "Total Messages", unread: "Unread", posts: "Blog Posts", portfolio: "Portfolio" },
      recent: "Recent Messages",
      save: "Save",
      delete: "Delete",
      edit: "Edit",
      new: "New",
      confirm: "Are you sure?",
      saved: "Saved.",
      deleted: "Deleted.",
      status: { all: "All", new: "New", read: "Read", replied: "Replied" },
      passwordChange: "Change Password",
      currentPw: "Current Password",
      newPw: "New Password",
      changePw: "Update Password",
    },
  },
};

export const TESTIMONIALS = {
  tr: [
    { q: "Larcraft ile çalışmak, bir ajansla değil, bir vizyonla çalışmaktır.", n: "Ayşe Y.", c: "Bloom Beverage" },
    { q: "Sosyal medyada 6 ayda %220 büyüme. Sayılar her şeyi anlatıyor.", n: "Mehmet E.", c: "Nova FinTech" },
    { q: "Sanatçımızın PR sürecini başka bir seviyeye taşıdılar.", n: "Cem A.", c: "Echo Music" },
  ],
  en: [
    { q: "Working with Larcraft isn't working with an agency — it's working with a vision.", n: "Ayşe Y.", c: "Bloom Beverage" },
    { q: "+220% growth on social in 6 months. The numbers say it all.", n: "Mehmet E.", c: "Nova FinTech" },
    { q: "They took our artist's PR to another level.", n: "Cem A.", c: "Echo Music" },
  ],
};
